// This site is marketing/UI only — account creation, login, credit purchase,
// and agent management all happen on the separate Gyeno customer portal.
//
// Set REACT_APP_CUSTOMER_PORTAL_URL in your .env before building, e.g.:
//   REACT_APP_CUSTOMER_PORTAL_URL=https://app.gyeno.ai
//
// TODO: replace the fallback below with your real customer portal URL.
export const CUSTOMER_PORTAL_URL =
  process.env.REACT_APP_CUSTOMER_PORTAL_URL || 'https://portal.gyeno.ai';
